/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const MediaProcessingStatus = {
    Pending: 'Pending',
    Processing: 'Processing',
    Complete: 'Complete',
    Failed: 'Failed'
};
export function MediaProcessingStatusFromJSON(json) {
    return MediaProcessingStatusFromJSONTyped(json, false);
}
export function MediaProcessingStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MediaProcessingStatusToJSON(value) {
    return value;
}
